
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'depot-view',
})
export default class DepotView extends Vue { }
